<template>
	<apexchart
		:width="width"
		:height="height"
		:options="options"
		:series="parsedData"
	/>
</template>
  
<script>
import VueApexCharts from "vue-apexcharts";

export default {
	name: "ReceivedCallsChart",
	props: {
		title: {
			type: String,
			default: "Ligações Recebidas"
		},
		width: {
			type: [Number, String],
			default: "100%",
		},
		height: {
			type: [Number, String],
			default: "100%",
		},
		loading: {
			type: Boolean,
		},
		data: {
			type: Object,
			default: () => ({})
		}
	},
	components: {
		apexchart: VueApexCharts,
	},
	data: function () {
		return {};
	},
	computed: {
		parsedData() {
			return Object.values(this.data)
		},
		options() {
			return {
				chart: {
					type: "donut",
				},
				title: {
					text: this.title,
					align: "center",
					style: {
						fontSize: "14px",
						fontWeight: "bold",
					},
				},
				plotOptions: {
					pie: {
						donut: {
							labels: {
								show: true,
								total: {
									show: true,
									label: "Total",
									fontSize: "14px",
									fontWeight: "bold",
									color: "black",
								},
							},
						},
					},
				},
				colors: ["#65ca65", "#478e47", "#d74d4d", "#c31a1a"],
				noData: {
					text: this.loading ? "Loading..." : "No Data",
				},
				labels: [
					"Atendidas | < 20s",
					"Atendidas | > 20s",
					"Abandonadas | < 20s",
					"Abandonadas | > 20s",
				],
				legend: {
					position: "bottom",
					horizontalAlign: "center",
				},
			};
		},
	},
};
</script>

<style lang="scss" scoped>

</style> 
  